<template>
  <div class="col-lg-12 col-xl-12 stretch-card">
    <div class="card">
      <div class="card-header">
        <h4 style="margin-right: 5px" class="float-start">TRANSPORT ORDER | STATUS: ASSIGNED </h4>


        <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs" style="margin-right: 5px"
          @click.prevent="downloadData()">
          <i class="link-icon" data-feather="download"></i>
          {{ $t("downloadData") }} .xlsx
        </button>
      </div>

      <div class="card-body">

        <div class="table-responsive" style="overflow-y: auto;">
          <div class="col-sm-12">

            <vue-good-table title="list-order-ct" mode="remote"
              :select-options="{ enabled: selectOnCheckboxOnly, selectOnCheckboxOnly: true, selectionText: $t('data_selected'), clearSelectionText: $t('clear'), }"
              @on-selected-rows-change="selectionChanged" @on-page-change="onPageChange" @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="totalRecords"
              :line-numbers="true" :isLoading.sync="isLoading" :pagination-options="{ enabled: true, }" :rows="rows"
              :columns="filteredColumns">
              <!-- <div slot="table-actions">
                {{ $t("no_select_data") }}
              </div> -->
              <div slot="selected-row-actions">
                <!-- <button class="btn btn-success btn-xs" style="margin-right:20px;" @click="sendOrder"> <i class="mdi mdi-send-outline"></i> {{ $t("send_order_txt") }}</button> -->
                <button class="btn btn-success btn-xs mr-5" style="margin-right:20px;" @click="sendOrder"
                  v-if="btnSendOrder"> <i class="mdi mdi-send-outline"></i> {{ $t("send_order_txt") }} </button>

                <button @click="closeLoad" v-if="btnCloseLoad" class="btn btn-warning btn-xs mr-5"
                  style="margin-right:20px;">
                  Close Load </button>

                <button @click="modifyOrder" v-if="btnModify" class="btn btn-primary btn-xs mr-5"
                  style="margin-right:20px;">
                  Modify Order </button>

                <button @click="appointLoad" v-if="btnPointLoad" class="btn btn-success btn-xs mr-5"
                  style="margin-right:20px;">
                  Appoint Load</button>

                <button @click="appointVoidReRoute" v-if="btnVoidOrder" class="btn btn-secondary btn-xs mr-5"
                  style="margin-right:20px;">
                  Void</button>

                <button class="btn btn-danger btn-xs mr-5" style="margin-right:20px;" @click="cancelOrder"><i
                    class="mdi mdi-close"></i> {{
                      $t("reject_order_txt") }} </button>

                <button class="btn btn-warning btn-xs ml-5" style="margin-right:20px;" @click="closeOrder"
                  v-if="btnCloseOrder"><i class="mdi mdi-close-box-outline"></i>{{ $t("close_order_txt") }}</button>

                <button v-if="btnEndTrip" class="btn btn-warning btn-xs ml-5" style="margin-right:20px; background-color:#e67e22; border-color:#e67e22;" @click="openEndTrip"
                  ><i class="mdi mdi-flag-checkered"></i> End Trip</button>



              </div>



              <template slot="table-row" slot-scope="props">


                <span v-if="props.column.field == 'actions'">
                  <a v-if="company_code === 'LINC' || company_code === 'BP' && permision_role.method_read"
                    title="Detail" @click.prevent="detailData(props.index, props.row)">
                    <i class="mdi mdi-eye" style="font-size:16px"></i>
                  </a>
                </span>



                <span v-else-if="props.column.field == 'order_no'">
                  <a style="color: #ab0635;text-decoration: none; cursor: pointer; " title="Detail Maps" @click.prevent="
                    clickOrder(props.row)
                    ">
                    {{ props.row.order_no }}

                  </a>
                </span>

                <span v-else-if="props.column.field == 'shipwith_ref'">
                  <!-- && props.row.load_id -->
                  <a href="#" @click.prevent="selectedShifWithReff(props.row.shipwith_ref)">
                    {{ props.row.shipwith_ref }}
                  </a>

                </span>


                <!-- <span v-else-if="props.column.field == 'request'"> 
                        < !-- && props.row.load_id -- >
                        <a href="#" v-if="!props.row.load_id" title="Reschedule" @click.prevent="
                          requestRescheduleder(props.row)
                        "><i class="mdi mdi-calendar-clock" style="font-size:16px"></i>
                        </a>
                      </span>-->


                <span v-else-if="props.column.field == 'pick_plan'">
                  <div :style="checkPickPlanDate(props.row.pick_plan)">
                    {{ $moment(props.row.pick_plan).format("D MMM yyyy h:mm:ss A") }}
                  </div>

                </span>
                <span v-else-if="props.column.field == 'submit_time'">

                  <div :style="checkSubmitDate(props.row)">
                    {{ $moment(props.row.submit_time).format("D MMM yyyy h:mm:ss A") }}
                  </div>

                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>

          </div>
        </div>



      </div>

    </div>
    <modal-reject-data :showModal="showModalRejectData" :data="this.transport_order_header_ids"
      @closeModal="closeMyModal"></modal-reject-data>
    <modal-request-reschedule :showModal="showModalRequestReschedule" :data="passData" @closeModal="closeMyModal">
    </modal-request-reschedule>

    <modal-point-load :showModal="showModalPointLoad" :data="this.rowsSelection" @closeModal="closeMyModal">
    </modal-point-load>


    <modal-rpa :showModal="showModalRpa" :data="{ 'shipwithref': shipwithref }" @closeModal="closeMyModal">
    </modal-rpa>

    <modal-void-order :showModal="showModalVoidOrder" :data="this.dataVoidOrder" @closeModal="closeMyModal">
    </modal-void-order>

    <!-- Modal Modify Order -->
    <div class="modal fade" :class="{ show: showModalModifyOrder, 'd-block': showModalModifyOrder }" id="modalModifyOrder" tabindex="-1" role="dialog" aria-labelledby="modalModifyOrderLabel" aria-hidden="true" v-if="showModalModifyOrder">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" v-if="modifyOrderData">
          <div class="modal-header">
            <h5 class="modal-title" id="modalModifyOrderLabel">Order Detail</h5>
            <button type="button" class="btn-close" @click="closeModifyModal" aria-label="Close"></button>
          </div>
          <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
            <div style="overflow: visible;">
              <table class="table table-sm table-borderless">
                <tbody>
                  <tr>
                    <td style="width: 25%; font-weight: bold;">Customer</td>
                    <td>: {{ modifyOrderData.company?.name || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Load Id</td>
                    <td>: {{ modifyOrderData.load_id || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Order No</td>
                    <td>
                      : <input v-model="modifyOrderForm.order_no" class="form-control form-control-sm d-inline-block" style="width: 250px;" />
                    </td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Shipwith Ref</td>
                    <td>: {{ modifyOrderData.shipwith_ref || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Tonase</td>
                    <td>
                      : <input type="number" v-model="modifyOrderForm.tonnage" class="form-control form-control-sm d-inline-block" style="width: 120px;" /> Kg
                    </td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Pickup</td>
                    <td>: {{ modifyOrderData.pick_plan || '' }} - {{ modifyOrderData.pick_name || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Drop</td>
                    <td>: {{ modifyOrderData.dest_plan || '' }} - {{ modifyOrderData.dest_name || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Carrier</td>
                    <td>: {{ modifyOrderData.carrier || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Type Truck</td>
                    <td>: {{ modifyOrderData.type_truck || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Vehicle No</td>
                    <td>: {{ modifyOrderData.vehicle_no || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Driver</td>
                    <td>: {{ modifyOrderData.driver_name || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Automatic Process</td>
                    <td>: {{ modifyOrderData.auto_load || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Customer Dest</td>
                    <td>: {{ modifyOrderData.company_name || '' }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;">Ship To</td>
                    <td>
                      <div style="width: 250px; position: relative; z-index: 1050;">
                        <multiselect v-model="modifyOrderForm.ship_to" :options="fetchShipTo" label="name" track-by="name" placeholder="-- Pilih Ship To --">
                          <span slot="noResult">-</span>
                        </multiselect>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="card mt-3">
              <div class="card-header d-flex justify-content-between align-items-center p-2">
                <h6 class="card-title mb-0" style="font-size: 14px;">Material List</h6>
                <button type="button" class="btn btn-primary btn-xs" @click="addModifyMaterialRow">
                  <i class="mdi mdi-plus"></i> Add Material
                </button>
              </div>
              <div class="card-body p-2">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered mb-0">
                    <thead>
                      <tr>
                        <th style="width: 5%">#</th>
                        <th style="width: 20%">Product Code</th>
                        <th style="width: 20%">Product Name</th>
                        <th style="width: 15%">SJ No</th>
                        <th style="width: 15%">Order Qty</th>
                        <th style="width: 20%">Description</th>
                        <th style="width: 5%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in modifyOrderForm.transport_order_material" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <input type="text" class="form-control form-control-sm" v-model="item.material_code" placeholder="Product Code" />
                        </td>
                        <td>
                          <input type="text" class="form-control form-control-sm" v-model="item.material_name" placeholder="Product Name" />
                        </td>
                        <td>
                          <input type="text" class="form-control form-control-sm" v-model="item.sj_no" placeholder="SJ No" />
                        </td>
                        <td>
                          <input type="number" class="form-control form-control-sm" v-model="item.order_qty" placeholder="Order Qty" />
                        </td>
                        <td>
                          <input type="text" class="form-control form-control-sm" v-model="item.material_desc" placeholder="Description" />
                        </td>
                        <td class="text-center">
                          <button type="button" class="btn btn-danger btn-xs" @click="removeModifyMaterialRow(index)" v-if="modifyOrderForm.transport_order_material.length > 1">
                            <i class="mdi mdi-delete"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div v-if="modifyOrderError" class="alert alert-danger mt-3 mb-0" role="alert">
              {{ modifyOrderError }}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModifyModal">CANCEL</button>
            <button type="button" class="btn btn-primary" :disabled="isSubmittingModify" @click="submitModifyOrder">
              <span v-if="isSubmittingModify" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              SEND TO BLUJAY
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-if="showModalModifyOrder"></div>

    <!-- Modal End Trip -->
    <div class="modal fade" :class="{ show: showModalEndTrip, 'd-block': showModalEndTrip }"
      id="modalEndTrip" tabindex="-1" role="dialog" aria-labelledby="modalEndTripLabel" aria-hidden="true" v-if="showModalEndTrip">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title text-center w-100" id="modalEndTripLabel">END TRIP SHIPMENT</h5>
          </div>
          <div class="modal-body">
            <h6 class="text-center mb-3">Shipment Summary</h6>
            <div class="table-responsive">
              <table class="table table-sm table-bordered mb-2">
                <thead>
                  <tr>
                    <th>Load Id</th>
                    <th>Order No</th>
                    <th>Carrier</th>
                    <th>Vehicle No</th>
                    <th>Pickup Name</th>
                    <th>Destination Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in endTripData" :key="idx">
                    <td>{{ row.load_id }}</td>
                    <td>{{ row.order_no }}</td>
                    <td>{{ row.carrier }}</td>
                    <td>{{ row.vehicle_no }}</td>
                    <td>{{ row.pick_name }}</td>
                    <td>{{ row.dest_name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="text-success text-center mb-0" style="font-size:12px;">
              <strong>Notes :</strong> End Trip akan otomatis menyelesaikan trip order McEasy
            </p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button type="button" class="btn btn-danger btn-sm"
              :disabled="isSubmittingEndTrip"
              @click="submitEndTrip">
              <span v-if="isSubmittingEndTrip" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              End Trip
            </button>
            <button type="button" class="btn btn-secondary btn-sm ms-2"
              :disabled="isSubmittingEndTrip"
              @click="showModalEndTrip = false">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-if="showModalEndTrip"></div>

  </div>





</template>

<script>
// import Vue from 'vue';
import ModalTransportOrderCtRejectMass from "@/components/modal/modalTransportOrderCtRejectMass.vue";
import ModalRequestReschedule from "@/components/modal/modalRequestReschedule.vue";
import ModalRpa from "@/components/modal/modalRpa";
import ModalPointLoad from "@/components/modal/modalPointLoad.vue";
import ModalVoidOrder from "@/components/modal/modalVoidOrder.vue";
import multiselect from "vue-multiselect";

export default {
  name: "TransportOrderCtAssigned",
  components: {
    multiselect: multiselect,
    "modal-reject-data": ModalTransportOrderCtRejectMass,
    "modal-request-reschedule": ModalRequestReschedule,
    "modal-rpa": ModalRpa,
    "modal-point-load": ModalPointLoad,
    "modal-void-order": ModalVoidOrder,
  },
  props: {
    dateRange: { type: [Object, Array] },
    status: String
  },

  data() {
    return {
      fetchShipTo:[],
      btnModify: false,
      btnPointLoad: false,
      btnVoidOrder: false,
      btnSendOrder: false,
      btnCloseOrder: false,
      btnEndTrip: false,
      showModalEndTrip: false,
      endTripData: [],
      isSubmittingEndTrip: false,
      company_code: "",
      selectOnCheckboxOnly: false,
      shipwithref: "",
      showModalRpa: false,
      showModalRejectData: false,
      showModalRequestReschedule: false,
      passData: [],
      maxToasts: 100,
      ORDER_RESPONSE_TIME: 0,
      position: "up right",
      closeBtn: true,
      btnCloseLoad: false,
      isLoading: false,
      showModalPointLoad: false,
      showModalVoidOrder: false,
      showModalModifyOrder: false,
      modifyOrderData: null,
      modifyOrderForm: {
        order_no: "",
        tonnage: "",
        ship_to: null,
        transport_order_material: []
      },
      isSubmittingModify: false,
      modifyOrderError: "",
      errors: [],
      permision_role: [],
      permision_role_extra_1: [],
      permision_role_extra_2: [],
      permision_role_extra_3: [],
      transport_order_header_ids: [],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      dataVoidOrder:[],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [

        {
          label: "Status P2H",
          field: "p2h_checklist_result",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Status UJO",
          field: "p2h_approval",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Status TMS",
          field: "status_tms",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Status", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },



        {
          label: "Close Date",
          field: "complete_date",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Customer", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Shipment Type",
          field: "shipment_type",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Shipment", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        


        {
          label: "Customer",
          field: "company.name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Customer", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Vehicle No",
          field: "vehicle_no",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Vehicle No", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Type Truck",
          field: "type_truck",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Type Truck", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Driver",
          field: "driver_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Type Truck", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Load Id",
          field: "load_id",
          width: '100px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Load Id", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Shipment Number",
          field: "order_no",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Order No", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "ShipWithRef",
          field: "shipwith_ref",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ShipWithRef", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Submit Order",
          field: "assign_time",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Planing", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("pickup_plan_txt"),
          field: "pick_plan",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("pickup_plan_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Pick Location",
          field: "pick_name",
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy h:mm:ss a',//'dd MMM yyyy',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("pick_plan_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Dest Location",
          field: "dest_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Destination", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: this.$t("dest_plan_txt"),
          field: "dest_plan",
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy h:mm:ss a',//'dd MMM yyyy',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("dest_plan_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Actual Duration",
          field: "actual_duration",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Destination", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Tonnage (kg)",
          field: "tonnage",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Tonnage", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },



        {
          label: "Location",
          field: "dest_location",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Tonnage", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Auto Load",
          field: "auto_load",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Auto Load", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Carier",
          field: "carrier",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Carier", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Assign Time",
          field: "assign_time",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Assign by",
          field: "assign_by",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },



        {
          label: "Remarks",
          field: "remarks",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Trailer No",
          field: "trailer_no",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Container",
          field: "container",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "shipment Type",
          field: "shipment_type",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("action_txt"),
          field: "actions",
          sortable: false,
        },
        // {
        //   label: "Request",
        //   field: "request",
        //   sortable: false,
        // },
      ],
      rows: [],
      rowsSelection: [],
    };
  },
  watch: {
    dateRange: {
      handler(newVal) {
        console.log(newVal);
        this.loadItems();
      },

    },
  },
  computed: {
    //Hide column assigned ( status tms,shipwithreff, actual duration, auto load, carrier, assign by, tindakan )
    filteredColumns() {
      return this.columns.map(column => {
        if ((column.field === 'shipwith_ref'
          || column.field === 'status_tms'
          || column.field === 'actual_duration'
          || column.field === 'auto_load'
          || column.field === 'carrier'
          || column.field === 'assign_by'
          || column.field === 'actions'
          // column.field !== 'request'

        ) &&
          !(this.detailUser.company_detail.code === 'BP' || this.detailUser.company_detail.code === 'LINC')) {
          return { ...column, hidden: true }; // Tandai kolom sebagai `hidden`
        }
        return { ...column, hidden: false }; // Kolom lain tidak tersembunyi
      });
    },
  },
  methods: {
    closeMyModal() {
      //this.rowsSelection = [];
      this.showModalPointLoad = false;
      this.showModalVoidOrder = false;
      this.showModalRejectData = false;
      this.showModalRequestReschedule = false;
      this.showModalRpa = false;
      this.dataVoidOrder  = [];
      this.$nextTick(() => {
        this.rowsSelection = [];
        this.loadItems();
      });
    },

    selectedShifWithReff(ev) {
      this.shipwithref = ev;
      this.showModalRpa = true;
    },


    requestRescheduleder(row) {
      this.passData = row;
      this.passData.source = "CT";
      this.showModalRequestReschedule = true;
    },

    checkSubmitDate(row) {
      const dateNow = this.$moment(new Date()).format("YYYY-MM-DD h:mm:ss");
      const dateData = this.$moment(row.submit_time).format("YYYY-MM-DD h:mm:ss");
      const dateDataPickup = this.$moment(row.pick_plan);
      const diff_in_millis = Math.abs(new Date(dateData) - new Date(dateNow))
      const diff_in_minutes = diff_in_millis / 60000
      const precentaceData = (diff_in_minutes * 100) / 25


      var hoursDataPickup = dateDataPickup.diff(dateNow, 'hours')
      if (hoursDataPickup > 48) {
        return "";
      } else {

        if (diff_in_minutes > this.ORDER_RESPONSE_TIME) {

          return {
            "background-color": "red",
            "color": "white"
          }

        } else if (precentaceData > 25) {
          return {
            "background-color": "yellow",
            "color": "black"
          }
        } else {
          return "";
        }

      }
    },

    checkPickPlanDate(val) {
      const dateNow = this.$moment(new Date()).format("YYYY-MM-DD") + " 23:59:59";
      const dateData = this.$moment(val).format("YYYY-MM-DD") + " 23:59:59";
      if (new Date(dateData) < new Date(dateNow)) {

        return {
          "background-color": "red",
          "color": "white"
        }

      } else if (new Date(dateData) > new Date(dateNow)) {

        return ""

      } else {

        return {
          "background-color": "yellow",
          "color": "black"
        }

      }
    },

    closeLoad() {

    },

    selectionChanged(ev) {
      // console.log(ev);
      this.btnSendOrder = false;
      this.btnModify = false;
      this.btnPointLoad = false;
      this.btnVoidOrder = false;
      this.rowsSelection = [];
      this.transport_order_header_ids = [];
      this.rowsSelection = ev.selectedRows;


      this.rowsSelection.forEach((item) => {

        this.transport_order_header_ids.push(item.transport_order_header_id);

        if (item.load_id == null || !/^\d+$/.test(item.load_id.toString())) {
          if (item.queue_rpa.status == 'QUEUE' || item.queue_rpa.status == 'PROCESSING') {
            this.btnSendOrder = false;
            this.btnCloseOrder = false;
          } else {
            this.btnSendOrder = true;
            this.btnCloseOrder = false;
          }

        } else {
          this.btnCloseOrder = true;

          if (this.rowsSelection.length === 1 && this.permision_role_extra_1.method_custom1) {
            this.btnModify = true;
          } else {
            this.btnModify = false;
          }


          if (this.rowsSelection.length === 1 && this.permision_role_extra_1.method_custom2) {
            this.btnCloseLoad = true;
          } else {
            this.btnCloseLoad = false;
          }


          if (this.rowsSelection.length === 1 && this.permision_role_extra_2.method_custom1) {
            this.btnPointLoad = true;
          } else {
            this.btnPointLoad = false;
          }


          const allowedBranches = ["JAKARTA", "SURABAYA"];

          this.btnVoidOrder =
            this.rowsSelection.length === 1 &&
            this.permision_role_extra_3.method_update &&
            allowedBranches.includes((item.branch_name || "").toUpperCase());
          //if (this.rowsSelection.length === 1 && this.permision_role_extra_3.method_update && item.branch_name?.toUpperCase() === "JAKARTA") {
            //this.btnVoidOrder = true;
          //} else {
            //this.btnVoidOrder = false;
          //}

          this.btnEndTrip =
            this.permision_role.method_custom3;

          // console.log(item)


        }


      });

    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;

      this.company_code = userDatas.sub.company_detail.code;

      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      let rolePermision_extra_1 = [];
      let rolePermision_extra_2 = [];
      let rolePermision_extra_3 = [];

      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'TransportOrderHeaderCtController') {
          rolePermision = permision;
        }

        if (permision.permission.controller == 'TransportOrderHeaderCtModifyController') {
          rolePermision_extra_1 = permision;
        }

        if (permision.permission.controller == 'TransportOrderHeaderCtPointLoadController') {
          rolePermision_extra_2 = permision;
        }

        if (permision.permission.controller == 'TransportOrderHeaderCtVoidOrderController') {
          rolePermision_extra_3 = permision;
        }

      });
 

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
      this.permision_role_extra_1 = rolePermision_extra_1;
      this.permision_role_extra_2 = rolePermision_extra_2;
      this.permision_role_extra_3 = rolePermision_extra_3;

      if (this.$route.query.msg) {
        if (this.$route.query.status == 200) {
          this.success(this.$route.query.msg)
        } else {
          this.error(this.$route.query.msg)
        }

      }

      if (this.permision_role.method_custom5) {

        if (this.company_code === 'LINC' || this.company_code === 'BP') {
          this.selectOnCheckboxOnly = true;
        } else {
          this.selectOnCheckboxOnly = false;
        }

      }


    },




    sendOrder() {

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // this.loadingSubmiting();
          this.fade(true);
          let data = {
            resubmit: "YES",
            transport_order_header_ids: this.transport_order_header_ids
          }
          const baseURI = this.$settings.endPoint + "control-tower/transport-order-header/send-order-to-blujay";
          this.$http
            .post(baseURI, data, { timeout: 200000 })
            .then((response) => {
              // this.loading();
              if (response.data.status === 200) {

                // response.data.datas.messages.forEach((item) => {
                //   this.success(item);
                // });

                this.success2(response.data.datas.messages);
                this.loadItems();
                this.isloading = false;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch(error => {
              this.isLoading = false;
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {

                if (error.response) {

                  this.errors = error.response.data.errors;

                  if (error.response.status === 422) {
                    var datas = error.response.data.datas;
                    var textResponse = "";
                    if (this.errors == "carrier_deactived") {

                      textResponse =
                        "<p style='text-align:center'>Order ini tidak di perkenankan untuk dikirim karena carrier ini sudah di BLOCK <br> Informasi Block :</p> ";
                      datas.forEach(function (data) {
                        textResponse += "<br> Status : " + datas[0].status + "<br> waktu : " + data.deactived_date +
                          "<br>Alasan di block : " + data.deactived_reason + " <br><hr>";
                      });
                      textResponse += "<br><p>Mohon hubungi Department FA untuk membuka Block</p>";

                      this.$swal({
                        width: "600px",
                        icon: "warning",
                        title: "Warning !!!!",
                        html: textResponse,
                      })
                    } else if (this.errors == 'month_pick_plan_diff') {

                      textResponse += "<p style='text-align:center'>Shipment ini tidak bisa di submit ke blujay di karenakan dalam satu shipwithreff terdapat order yang berbeda bulan : </p>";
                      textResponse += "<table style='width:100%; border-collapse: collapse; border: 1px solid black;'>";
                      textResponse += "<tr><th style='border: 1px solid black;'>Order No</th><th style='border: 1px solid black;'>Shipwithreff</th><th style='border: 1px solid black;'>Pickplan</th></tr>";
                      datas.forEach(function (data) {
                        textResponse += `<tr><td style='border: 1px solid black;'>${data.order_no}</td><td style='border: 1px solid black;'>${data.shipwith_ref}</td><td style='border: 1px solid black;'>${data.pick_plan_date}</td></tr>`;
                      });
                      textResponse += "</table>";
                      textResponse += "<br><p>Silahkan menghubungi admin sales / CS untuk melakukan VOID salah satu shipment</p>";


                      this.$swal({
                        width: "600px",
                        icon: "warning",
                        title: "Warning !!!!",
                        html: textResponse,
                      })
                    } else if (this.errors == 'invalid_remarks_cust_tujuan') {
                      let textResponse = "<p style='text-align:center'>Invalid Remarst Custumer Destination : </p> ";
                      textResponse += "<table style='width:100%; border-collapse: collapse; border: 1px solid black;'>";
                      textResponse += "<tr><td style='border: 1px solid black;'>Order No</td><td style='border: 1px solid black;'>Shipwithreff</td><td style='border: 1px solid black;'>Remarks</td></tr>";
                      datas.forEach(function (data) {
                        textResponse += `<tr><td style='border: 1px solid black;'>${data.order_no}</td><td style='border: 1px solid black;'>${data.shipwith_ref}</td><td style='border: 1px solid black;'>${data.remarks}</td></tr>`;
                      });
                      textResponse += "</table>";
                      textResponse += "<br><p></p>";

                      this.$swal({
                        width: "600px",
                        icon: "warning",
                        title: "Warning !!!!",
                        html: textResponse,
                      })
                    } else if (this.errors == 'order_already_has_load_id') {
                      textResponse = "<p style='text-align:center'>The order number below already has a load ID, it cannot be resubmitted : </p> ";
                      textResponse += "<table style='width:100%; border-collapse: collapse; border: 1px solid black;'>";
                      textResponse += "<tr><td style='border: 1px solid black;'>Order No</td><td style='border: 1px solid black;'>Shipwithreff</td style='border: 1px solid black;'><td>Load id</td></tr>";
                      datas.forEach(function (data) {
                        textResponse += `<tr><td style='border: 1px solid black;'>${data.order_no}</td><td style='border: 1px solid black;'>${data.shipwith_ref}</td><td style='border: 1px solid black;'>${data.load_id}</td></tr>`;
                      });
                      textResponse += "</table>";
                      textResponse += "<br><p></p>";

                      this.$swal({
                        width: "600px",
                        icon: "warning",
                        title: "Warning !!!!",
                        html: textResponse,
                      })
                    } else {
                      this.resultError(error.response.data.errors);
                    }


                  } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  } else if (error.response.status === 401) {
                    this.$router.push("/authorized-error");
                  } else {
                    this.$router.push('/page-not-found');
                  }
                }

              }

            });
        }
      });




    },




    closeOrder() {

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // this.loadingSubmiting();
          this.fade(true);
          let data = {
            transport_order_header_ids: this.transport_order_header_ids
          }
          const baseURI =
            this.$settings.endPoint + "control-tower/transport-order-header/close";
          this.$http
            .post(baseURI, data, { timeout: 200000 })
            .then((response) => {
              // this.loading();
              if (response.data.status === 200) {

                // response.data.datas.messages.forEach((item) => {
                //   this.success(item);
                // });
                this.success2(response.data.datas.messages);
                this.loadItems();
                this.isloading = false;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch(error => {
              this.isLoading = false;
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {

                if (error.response) {

                  this.errors = error.response.data.errors;

                  if (error.response.status === 422) {
                    var datas = error.response.data.datas;
                    var textResponse = "";
                    if (this.errors == "carrier_deactived") {

                      textResponse =
                        "<p style='text-align:center'>Order ini tidak di perkenankan untuk dikirim karena carrier ini sudah di BLOCK <br> Informasi Block :</p> ";
                      datas.forEach(function (data) {
                        textResponse += "<br> Status : " + datas[0].status + "<br> waktu : " + data.deactived_date +
                          "<br>Alasan di block : " + data.deactived_reason + " <br><hr>";
                      });
                      textResponse += "<br><p>Mohon hubungi Department FA untuk membuka Block</p>";

                      this.$swal({
                        width: "600px",
                        icon: "warning",
                        title: "Warning !!!!",
                        html: textResponse,
                      })
                    } else if (this.errors == 'month_pick_plan_diff') {

                      textResponse += "<p style='text-align:center'>Shipment ini tidak bisa di submit ke blujay di karenakan dalam satu shipwithreff terdapat order yang berbeda bulan : </p>";
                      textResponse += "<table style='width:100%; border-collapse: collapse; border: 1px solid black;'>";
                      textResponse += "<tr><th style='border: 1px solid black;'>Order No</th><th style='border: 1px solid black;'>Shipwithreff</th><th style='border: 1px solid black;'>Pickplan</th></tr>";
                      datas.forEach(function (data) {
                        textResponse += `<tr><td style='border: 1px solid black;'>${data.order_no}</td><td style='border: 1px solid black;'>${data.shipwith_ref}</td><td style='border: 1px solid black;'>${data.pick_plan_date}</td></tr>`;
                      });
                      textResponse += "</table>";
                      textResponse += "<br><p>Silahkan menghubungi admin sales / CS untuk melakukan VOID salah satu shipment</p>";


                      this.$swal({
                        width: "600px",
                        icon: "warning",
                        title: "Warning !!!!",
                        html: textResponse,
                      })
                    } else if (this.errors == 'invalid_remarks_cust_tujuan') {
                      let textResponse = "<p style='text-align:center'>Invalid Remarst Custumer Destination : </p> ";
                      textResponse += "<table style='width:100%; border-collapse: collapse; border: 1px solid black;'>";
                      textResponse += "<tr><td style='border: 1px solid black;'>Order No</td><td style='border: 1px solid black;'>Shipwithreff</td><td style='border: 1px solid black;'>Remarks</td></tr>";
                      datas.forEach(function (data) {
                        textResponse += `<tr><td style='border: 1px solid black;'>${data.order_no}</td><td style='border: 1px solid black;'>${data.shipwith_ref}</td><td style='border: 1px solid black;'>${data.remarks}</td></tr>`;
                      });
                      textResponse += "</table>";
                      textResponse += "<br><p></p>";

                      this.$swal({
                        width: "600px",
                        icon: "warning",
                        title: "Warning !!!!",
                        html: textResponse,
                      })
                    } else if (this.errors == 'order_already_has_load_id') {
                      textResponse = "<p style='text-align:center'>The order number below already has a load ID, it cannot be resubmitted : </p> ";
                      textResponse += "<table style='width:100%; border-collapse: collapse; border: 1px solid black;'>";
                      textResponse += "<tr><td style='border: 1px solid black;'>Order No</td><td style='border: 1px solid black;'>Shipwithreff</td style='border: 1px solid black;'><td>Load id</td></tr>";
                      datas.forEach(function (data) {
                        textResponse += `<tr><td style='border: 1px solid black;'>${data.order_no}</td><td style='border: 1px solid black;'>${data.shipwith_ref}</td><td style='border: 1px solid black;'>${data.load_id}</td></tr>`;
                      });
                      textResponse += "</table>";
                      textResponse += "<br><p></p>";

                      this.$swal({
                        width: "600px",
                        icon: "warning",
                        title: "Warning !!!!",
                        html: textResponse,
                      })
                    } else {
                      this.resultError(error.response.data.errors);
                    }


                  } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  } else if (error.response.status === 401) {
                    this.$router.push("/authorized-error");
                  } else {
                    this.$router.push('/page-not-found');
                  }
                }

              }

            });
        }
      });




    },


    cancelOrder() {
      this.showModalRejectData = true;
    },

    loadShipTo() {
      this.fetchShipTo=[];
      const baseURI =
        this.$settings.endPointCt + `master-lookup/index-view?unique_id=custan&limit=100`;
      return this.$http.get(baseURI).then((response) => {
        let data=response.data.datas.data;
        for (let index = 0; index < data.length; index++) {
          const element = {
            "name":data[index]['value'],
          };
          this.fetchShipTo.push(element);
        }
      

      });


    },


    /*
    async modifyOrderOldSwal() {
      await this.loadShipTo();
      let multiselectApp = null;

      this.$swal.fire({
        title: 'Order Detail',
        html: `
      <div style="text-align:left;">
        <table style="width:100%; border-collapse: collapse;">
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Customer</td>
            <td>: ${this.rowsSelection[0]?.company?.name || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Load Id</td>
            <td>: ${this.rowsSelection[0]?.load_id || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Order No</td>
            <td>: <input id="orderNo" class="swal2-input" 
                  value="${this.rowsSelection[0]?.order_no || ''}" 
                  style="width: 250px; margin:0;" /></td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Shipwitreff</td>
            <td>: ${this.rowsSelection[0]?.shipwith_ref || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Tonase</td>
            <td>: <input id="tonase" type="number" 
                  class="swal2-input" 
                  value="${this.rowsSelection[0]?.tonnage || ''}" 
                  style="width:100px; margin:0;" /> Kg</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Kode Produk</td>
            <td>: <input id="productCode" class="swal2-input" 
                  value="${this.rowsSelection[0]?.product_code || ''}" 
                  style="width: 250px; margin:0;" /></td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Nama Produk</td>
            <td>: <input id="productName" class="swal2-input" 
                  value="${this.rowsSelection[0]?.product_name || ''}" 
                  style="width: 250px; margin:0;" /></td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Nomor SJ</td>
            <td>: <input id="nomorSj" class="swal2-input" 
                  value="${this.rowsSelection[0]?.nomor_sj || ''}" 
                  style="width: 250px; margin:0;" /></td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Pickup</td>
            <td>: ${this.rowsSelection[0]?.pick_plan || ''} - ${this.rowsSelection[0]?.pick_name || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Drop</td>
            <td>: ${this.rowsSelection[0]?.dest_plan || ''} - ${this.rowsSelection[0]?.dest_name || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Carrier</td>
            <td>: ${this.rowsSelection[0]?.carrier || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Type Truck</td>
            <td>: ${this.rowsSelection[0]?.type_truck || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Vehicle No</td>
            <td>: ${this.rowsSelection[0]?.vehicle_no || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Driver</td>
            <td>: ${this.rowsSelection[0]?.driver_name || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Automatic Process</td>
            <td>: ${this.rowsSelection[0]?.auto_load || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;">Customer Dest</td>
            <td>: ${this.rowsSelection[0]?.company_name || ''}</td>
          </tr>
          <tr>
            <td style="padding:4px 8px; font-weight:bold;" colspan="2">Ship To</td>
          </tr>
          <tr>
            <td colspan="2">
              <div id="multiselect-container" style="width:250px; display:inline-block; vertical-align:middle; text-align:left;"></div>
            </td>  
          </tr>
        </table>
      </div>
    `,
        showCancelButton: true,
        confirmButtonText: 'SEND TO BLUJAY',
        cancelButtonText: 'CANCEL',
        showLoaderOnConfirm: true,
        didOpen: () => {
          const div = document.getElementById('multiselect-container');
          if (div) {
            multiselectApp = new Vue({
              el: div,
              data: () => ({
                selectedOption: this.fetchShipTo.find(item => item.name === (this.rowsSelection[0]?.ship_to || '')) || null,
                options: this.fetchShipTo
              }),
              render(h) {
                return h(multiselect, {
                  props: {
                    value: this.selectedOption,
                    options: this.options,
                    searchable: true,
                    label: 'name',
                    trackBy: 'name',
                    placeholder: '-- Pilih Ship To --'
                  },
                  on: {
                    input: (val) => {
                      this.selectedOption = val;
                    }
                  }
                });
              }
            });

            this.$nextTick(() => {
              const formElement = this.$swal.getPopup();
              if (formElement) {
                const observer = new MutationObserver((mutations) => {
                  mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                      const inputs = formElement.querySelectorAll('.multiselect__input');
                      inputs.forEach(input => {
                        input.removeAttribute('readonly');
                      });
                    }
                  });
                });

                const inputs = formElement.querySelectorAll('.multiselect__input');
                inputs.forEach(input => {
                  input.removeAttribute('readonly');
                  observer.observe(input, { attributes: true });
                });
              }
            });
          }
        },
        preConfirm: () => {
          let data = {
            order_no: document.getElementById('orderNo').value,
            tonnage: document.getElementById('tonase').value,
            product_code: document.getElementById('productCode').value,
            product_name: document.getElementById('productName').value,
            nomor_sj: document.getElementById('nomorSj').value,
            ship_to: (multiselectApp && multiselectApp.selectedOption ? multiselectApp.selectedOption.name : '') || this.rowsSelection[0]?.ship_to
          };

          const baseURI = this.$settings.endPoint +
            "control-tower/transport-order-header/modify-order/" +
            this.rowsSelection[0].transport_order_header_id;

          return this.$http.post(baseURI, data, { timeout: 200000 })
            .then((response) => {
              if (response.data.status === 200) {
                let msg = response.data.meta.datas;
                let pesan = "";
                msg.forEach((item) => {
                  pesan = item.message + "<p>* " + item.order_no + "</p>";
                });

                this.$swal({
                  icon: 'info',
                  backdrop: true,
                  title: "Information",
                  html: pesan,
                  showConfirmButton: true,
                  allowOutsideClick: false,
                  allowEscapeKey: false
                })

                this.loadItems();
                return true;
              } else {
                this.$swal.showValidationMessage(
                  `Error: ${response.data.errors?.messages[0] || 'Gagal update'}`
                );
                return false;
              }
            })
            .catch(error => {
              let msg = "Unexpected error";
              if (error.code == "ECONNABORTED") {
                msg = this.$t("check_internet_connection_txt");
                this.$swal.showValidationMessage(`Request failed: ${msg}`);
              } else if (error.response?.status === 422) {
                msg = "";
                const errData = error.response.data;
                if (errData.datas === "konfirmasi") {
                  const message = errData?.errors?.message?.[0] || "Apakah Anda yakin ingin melanjutkan?";

                  this.$swal({
                    title: "Konfirmasi",
                    text: message,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, lanjutkan",
                    cancelButtonText: "Batal",
                    showLoaderOnConfirm: true,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.isLoading = true;

                      const dataSendConfirm = {
                        order_no: data.order_no,
                        tonnage: data.tonnage
                      };
                      const baseURI2 = this.$settings.endPoint + "control-tower/transport-order-header/modify-order-yes/" + this.rowsSelection[0].transport_order_header_id;

                      this.$http.post(baseURI2, dataSendConfirm, { timeout: 10000 })
                        .then((response) => {
                          if (response.status === 200) {
                            this.isLoading = false;
                            this.errors = [];
                            this.success("Success Send data !!");
                            this.loadItems();
                          }
                        })
                        .catch(err2 => {
                          this.isLoading = false;

                          this.$swal({
                            icon: 'error',
                            backdrop: true,
                            title: "Information",
                            html: err2.response.data.errors.message,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false
                          })
                        });
                    }
                  });

                } else {
                  msg = JSON.stringify(error.response.data.errors);
                  this.$swal.showValidationMessage(`Request failed: ${msg}`);
                }

              } else if (error.response?.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response?.status === 401) {
                this.$router.push('/authorized-error');
              } else if (error.response?.status === 404) {
                this.$router.push('/page-not-found');
              }

            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      });
    },
    */

    async modifyOrder() {
      await this.loadShipTo();
      const selected = this.rowsSelection[0];
      if (!selected) return;

      this.modifyOrderData = selected;
      this.modifyOrderError = "";
      this.isSubmittingModify = false;

      let materials = [];
      if (selected.transport_order_material && selected.transport_order_material.length > 0) {
        materials = selected.transport_order_material.map(m => ({
          material_code: m.material_code || "",
          material_name: m.material_name || "",
          sj_no: m.sj_no || "",
          order_qty: m.order_qty || "",
          material_desc: m.material_desc || "",
        }));
      } else {
        materials = [
          {
            material_code: selected.product_code || "",
            material_name: selected.product_name || "",
            sj_no: selected.nomor_sj || "",
            order_qty: selected.order_qty || "",
            material_desc: "",
          }
        ];
      }

      let selectedShipTo = null;
      if (selected.ship_to) {
        selectedShipTo = this.fetchShipTo.find(item => item.name === selected.ship_to) || { name: selected.ship_to };
      }

      this.modifyOrderForm = {
        order_no: selected.order_no || "",
        tonnage: selected.tonnage || "",
        ship_to: selectedShipTo,
        transport_order_material: materials
      };

      this.showModalModifyOrder = true;
    },

    closeModifyModal() {
      this.showModalModifyOrder = false;
    },

    addModifyMaterialRow() {
      this.modifyOrderForm.transport_order_material.push({
        material_code: "",
        material_name: "",
        sj_no: "",
        order_qty: "",
        material_desc: "",
      });
    },

    removeModifyMaterialRow(index) {
      if (this.modifyOrderForm.transport_order_material.length > 1) {
        this.modifyOrderForm.transport_order_material.splice(index, 1);
      }
    },

    submitModifyOrder() {
      this.isSubmittingModify = true;
      this.modifyOrderError = "";

      let data = {
        order_no: this.modifyOrderForm.order_no,
        tonnage: this.modifyOrderForm.tonnage,
        ship_to: this.modifyOrderForm.ship_to?.name || "",
        transport_order_material: this.modifyOrderForm.transport_order_material
      };

      const baseURI = this.$settings.endPoint +
        "control-tower/transport-order-header/modify-order/" +
        this.modifyOrderData.transport_order_header_id;

      this.$http.post(baseURI, data, { timeout: 200000 })
        .then((response) => {
          this.isSubmittingModify = false;
          if (response.data.status === 200) {
            this.showModalModifyOrder = false;
            let msg = response.data.meta?.datas || [];
            let pesan = "";
            msg.forEach((item) => {
              pesan += item.message + "<p>* " + item.order_no + "</p>";
            });

            this.$swal({
              icon: 'info',
              backdrop: true,
              title: "Information",
              html: pesan || "Successfully updated!",
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false
            });

            this.loadItems();
          } else {
            this.modifyOrderError = response.data.errors?.messages?.[0] || 'Gagal update';
          }
        })
        .catch((error) => {
          this.isSubmittingModify = false;
          let msg = "Unexpected error";
          if (error.code == "ECONNABORTED") {
            msg = this.$t("check_internet_connection_txt");
            this.modifyOrderError = `Request failed: ${msg}`;
          } else if (error.response?.status === 422) {
            const errData = error.response.data;
            if (errData.datas === "konfirmasi") {
              this.showModalModifyOrder = false;
              const message = errData?.errors?.message?.[0] || "Apakah Anda yakin ingin melanjutkan?";

              this.$swal({
                title: "Konfirmasi",
                text: message,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Ya, lanjutkan",
                cancelButtonText: "Batal",
                showLoaderOnConfirm: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.isLoading = true;
                  const dataSendConfirm = {
                    order_no: data.order_no,
                    tonnage: data.tonnage,
                    transport_order_material: data.transport_order_material
                  };
                  const baseURI2 = this.$settings.endPoint + "control-tower/transport-order-header/modify-order-yes/" + this.modifyOrderData.transport_order_header_id;

                  this.$http.post(baseURI2, dataSendConfirm, { timeout: 10000 })
                    .then((response) => {
                      this.isLoading = false;
                      if (response.status === 200) {
                        this.errors = [];
                        this.success("Success Send data !!");
                        this.loadItems();
                      }
                    })
                    .catch(err2 => {
                      this.isLoading = false;
                      this.$swal({
                        icon: 'error',
                        backdrop: true,
                        title: "Information",
                        html: err2.response?.data?.errors?.message || "Failed to confirm",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false
                      });
                    });
                }
              });
            } else {
              msg = JSON.stringify(error.response.data.errors);
              this.modifyOrderError = `Request failed: ${msg}`;
            }
          } else if (error.response?.status === 500) {
            this.$router.push('/server-error');
          } else if (error.response?.status === 401) {
            this.$router.push('/authorized-error');
          } else if (error.response?.status === 404) {
            this.$router.push('/page-not-found');
          } else {
            this.modifyOrderError = `Request failed: ${error.message}`;
          }
        });
    },


    openEndTrip() {
      this.endTripData = this.rowsSelection;
      this.showModalEndTrip = true;
    },

    async submitEndTrip() {
      this.isSubmittingEndTrip = true;

      // Kumpulkan semua pipeline_assignment_ids dari semua selected rows
      let pipelineIds = [];
      this.endTripData.forEach(row => {
        if (row.pipeline_assignments && row.pipeline_assignments.length > 0) {
          row.pipeline_assignments.forEach(pa => {
            pipelineIds.push(String(pa.pipeline_assignments_id));
          });
        }
      });

      // Validasi: jika tidak ada pipeline_assignment_ids, tampilkan notif & batalkan
      if (pipelineIds.length === 0) {
        this.isSubmittingEndTrip = false;
        this.error("Tidak ditemukan Pipeline Assignment pada data yang dipilih. Pastikan order sudah memiliki pipeline assignment.");
        return;
      }

      const payload = {
        pipeline_assignment_ids: pipelineIds,
        status: "AVAILABLE"
      };

      const baseURI = this.$settings.endPoint + "control-tower/pipelines/update/";

      try {
        const response = await this.$http.post(baseURI, payload, { timeout: 200000 });
        this.isSubmittingEndTrip = false;
        this.showModalEndTrip = false;

        if (response.data.status === 200) {
          this.$swal({
            icon: 'success',
            title: 'END TRIP',
            html: '<strong style="color:#28a745; font-size:1.5em;">SUCCESS</strong><br><br><i class="mdi mdi-check-circle" style="font-size:3em; color:#28a745;"></i>',
            showConfirmButton: true,
            confirmButtonText: 'Ok',
            allowOutsideClick: false,
          }).then(() => {
            this.loadItems();
          });
        } else {
          this.resultError(response.data.errors);
        }
      } catch (error) {
        this.isSubmittingEndTrip = false;
        if (error.code === 'ECONNABORTED') {
          this.error(this.$t('check_internet_connection_txt'));
        } else if (error.response) {
          if (error.response.status === 422) {
            this.resultError(error.response.data.errors);
          } else if (error.response.status === 500) {
            this.$router.push('/server-error');
          } else if (error.response.status === 401) {
            this.$router.push('/authorized-error');
          } else {
            this.$router.push('/page-not-found');
          }
        }
      }
    },

    appointLoad() {
      this.showModalPointLoad = true;
    },

    appointVoidReRoute() {

      var statusNotAllowed    = ["COMPLETED","VOID","VOID BLUJAY","ACCEPTED"];
      var statusTmsAllowed    = ["NEW","PENDING - PAYABLE NOT FOUND","BILLABLE NOT FOUND","BILLABLE & PAYABLE NOT FOUND","ACCEPTED","ACCEPTED - WAITING APPOINT LOAD"];
      var rowSelection        = this.rowsSelection[0];

      if(statusNotAllowed.includes(rowSelection.order_status)){

        this.error("Order Status Not Allowed");

      }else{
        
        var load_id         = rowSelection.load_id;
        const numberPattern = /^\d+$/; 

        if(load_id.length === 0){

          this.error("Load ID is empty");

        }else if(!numberPattern.test(load_id)){
          
          this.error("Order has no Load Id");
          
        }else{

          if(load_id == "LeoGeneralError"){

            this.error("Load ID is LeoGeneralError");

          }else{

            if(statusTmsAllowed.includes(rowSelection.status_tms)){
              
              this.dataVoidOrder      = rowSelection;
              this.showModalVoidOrder = true;

            }else{

              this.error("Status TMS is "+rowSelection.status_tms);

            }

          }

        }

      }

      // console.log(rowSelection);

    },

    updateFormatDate(date) {
      let date_format = this.$moment(date).format("dd mmm yyyy");
      return date_format;
    },

    downloadData() {
      this.isLoading = true;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      const baseURI = this.$settings.endPoint + "control-tower/transport-order-header";
      //var columnFilters = this.serverParams.columnFilters;
      //var date_order = '';
      // if(this.serverParams.columnFilters.order_date!=''){
      //   date_order =this.$moment(this.serverParams.columnFilters.order_date).format("YYYY-MM-DD");
      // }
      //var columnFilters = this.serverParams.columnFilters;
      var pick_plan = '';
      if (this.serverParams.columnFilters.pick_plan != '') {
        pick_plan = this.$moment(this.serverParams.columnFilters.pick_plan).format("YYYY-MM-DD");
      }
      //var columnFilters = this.serverParams.columnFilters;
      var dest_plan = '';
      if (this.serverParams.columnFilters.dest_plan != '') {
        dest_plan = this.$moment(this.serverParams.columnFilters.dest_plan).format("YYYY-MM-DD");
      }
      var company_name = this.serverParams.columnFilters["company.name"];
      //  var transport_order_template_description = this.serverParams.columnFilters["transport_order_template.description"];
      //  var transport_order_template_tonnage     = this.serverParams.columnFilters["transport_order_template.tonnage"];
      //  var transport_order_template_cubic       = this.serverParams.columnFilters["transport_order_template.cubic"];
      var startDate = this.dateRange.startDate;
      var endDate = this.dateRange.endDate;
      //var status=this.status

      return this.$http
        .get(
          baseURI +
          `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&company_name=${company_name}&start=${startDate}&end=${endDate}&status_tms=${this.serverParams.columnFilters.status_tms}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&complete_date=${this.serverParams.columnFilters.complete_date}&shipment_type=${this.serverParams.columnFilters.complete_date}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&order_no=${this.serverParams.columnFilters.order_no}&pick_plan=${pick_plan}&dest_plan=${dest_plan}&tonnage=${this.serverParams.columnFilters.tonnage}&dest_location=${this.serverParams.columnFilters.dest_location}&order_status=${this.status}&assign_time=${this.serverParams.columnFilters.assign_time}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&actual_duration=${this.serverParams.columnFilters.actual_duration}&assign_time=${this.serverParams.columnFilters.assign_time}&assign_by=${this.serverParams.columnFilters.assign_by}&auto_load=${this.serverParams.columnFilters.auto_load}&p2h_checklist_result=${this.serverParams.columnFilters.p2h_checklist_result}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}&shipment_type=${this.serverParams.columnFilters.shipment_type}&trailer_no=${this.serverParams.columnFilters.trailer_no}&container=${this.serverParams.columnFilters.container}&download=download`,
          {
            responseType: "blob",
            timeout: 200000
          }
        )
        .then((response) => {

          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },



    editData(index, row) {
      var params = this.$onRandom(row.transport_order_header_id);
      window.location.href = "/ct-orders/edit/" + params;
    },

    detailData(index, row) {
      var params = this.$onRandom(row.transport_order_header_id);
      window.location.href = "/ct-orders/detail/" + params;
    },


    // load items is what brings back the rows from server
    loadItems() {
      this.isLoading = true;
      const baseURI = this.$settings.endPoint + "control-tower/transport-order-header";
      //var columnFilters = this.serverParams.columnFilters;
      //var date_order = '';
      // if(this.serverParams.columnFilters.order_date!=''){
      //   date_order =this.$moment(this.serverParams.columnFilters.order_date).format("YYYY-MM-DD");
      // }
      //var columnFilters = this.serverParams.columnFilters;
      var pick_plan = '';
      if (this.serverParams.columnFilters.pick_plan != '') {
        pick_plan = this.$moment(this.serverParams.columnFilters.pick_plan).format("YYYY-MM-DD");
      }
      //var columnFilters = this.serverParams.columnFilters;
      var dest_plan = '';
      if (this.serverParams.columnFilters.dest_plan != '') {
        dest_plan = this.$moment(this.serverParams.columnFilters.dest_plan).format("YYYY-MM-DD");
      }
      var company_name = this.serverParams.columnFilters["company.name"];
      //  var transport_order_template_description = this.serverParams.columnFilters["transport_order_template.description"];
      //  var transport_order_template_tonnage     = this.serverParams.columnFilters["transport_order_template.tonnage"];
      //  var transport_order_template_cubic       = this.serverParams.columnFilters["transport_order_template.cubic"];
      var startDate = this.$moment(this.dateRange.startDate).format("YYYY-MM-DD");
      var endDate = this.$moment(this.dateRange.endDate).format("YYYY-MM-DD");
      // var status=this.status
      //  console.log(this.status);

      return this.$http
        .get(
          baseURI +
          `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&company_name=${company_name}&start=${startDate}&end=${endDate}&status_tms=${this.serverParams.columnFilters.status_tms}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&complete_date=${this.serverParams.columnFilters.complete_date}&shipment_type=${this.serverParams.columnFilters.complete_date}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&order_no=${this.serverParams.columnFilters.order_no}&pick_plan=${pick_plan}&dest_plan=${dest_plan}&tonnage=${this.serverParams.columnFilters.tonnage}&dest_location=${this.serverParams.columnFilters.dest_location}&order_status=${this.status}&accept_time=${this.serverParams.columnFilters.accept_time}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&actual_duration=${this.serverParams.columnFilters.actual_duration}&assign_time=${this.serverParams.columnFilters.assign_time}&assign_by=${this.serverParams.columnFilters.assign_by}&auto_load=${this.serverParams.columnFilters.auto_load}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&p2h_checklist_result=${this.serverParams.columnFilters.p2h_checklist_result}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}&shipment_type=${this.serverParams.columnFilters.shipment_type}&trailer_no=${this.serverParams.columnFilters.trailer_no}&container=${this.serverParams.columnFilters.container}`,
          { timeout: 200000 }
        )
        .then((response) => {
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          //   if(this.status=='NEW'){
          //     this.$emit('passDataNew', this.totalRecords);
          //   }

          if (this.status == 'ASSIGNED-CT') {
            this.$emit('passDataAssigned', this.totalRecords);
          }

          // if(this.status=='REJECTED'){
          //   this.$emit('passDataRejected', this.totalRecords);
          // }

          // if(this.status=='COMPLETED'){
          //   this.$emit('passDataCompleted', this.totalRecords);
          // }

          // if(this.status=='RESCHEDULE'){
          //   this.$emit('passDataReschedule', this.totalRecords);
          // }

          // if(this.status=='REROUTE'){
          //   this.$emit('passDataReroute', this.totalRecords);
          // }

          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    clickOrder(order) {
      this.$emit('show_order', order);


    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },


    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    success2(msg) {
      let pesan = "";
      msg.forEach((item) => {
        pesan = pesan + "<p>* " + item + "</p>";
      });

      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: pesan,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })


    },


    loadingSubmiting() {


      this.$swal({
        icon: 'warning',
        backdrop: true,
        title: "Please wait",
        html: '<h2>SUBMITTING ORDER...</h2>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

    },


    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },


    logout() {
      this.$logoutUser();
      this.$router.push("/");
    },

    getSystemCode() {
      const baseURI = this.$settings.endPoint + "system-code/select?system_code=ORDER_RESPONSE_TIME";

      return this.$http
        .get(
          baseURI,
          { timeout: 200000 }
        )
        .then((response) => {
          var rows = response.data.datas.data;
          if (rows.length > 0) {
            this.ORDER_RESPONSE_TIME = rows[0].value;
          }

        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },

  },
  events: {},


  mounted() {
    this.fetchIt();
    this.loading();
    this.getSystemCode();


  },
};
</script>